// How the application presents itself under each address (owner, 2026-10-20): the country is decided by the ACCOUNT,
// never by where or under which address someone arrives (DR-122), so this is only a hint for the header — the same
// application answers at the .cl and the .py addresses. Any other host (localhost, an IP) shows no country.

export type CountryName = 'Chile' | 'Paraguay';

export function countryOfHost(hostname: string): CountryName | undefined {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  if (host.endsWith('.cl')) return 'Chile';
  if (host.endsWith('.py')) return 'Paraguay';
  return undefined;
}

/** "Funtour · Rooming List" plus the country when the address says one: "Funtour · Rooming List · Paraguay". */
export function appNameFor(base: string, hostname: string): string {
  const country = countryOfHost(hostname);
  return country === undefined ? base : `${base} · ${country}`;
}
